import React, { Component } from 'react';

import { getCharFilename } from './Utils.js';

const dataTeams = require('./data/dataTeams.json');
const COL_WIDTH = 70;
const XPADDING = 4;

class TeamChart extends Component {
    constructor(props){
        super(props);
        this.state = {mX: 0, mY: 0, clicked:false, xClick:0, xOff: 0};

        this.createTeamChart = this.createTeamChart.bind(this);
    }

    componentDidMount() {
        this.createTeamChart();
    }

    componentDidUpdate() {
        this.createTeamChart();
    }

    createTeamChart() {

    }

    onMouseDown(e) {
        let x = e.clientX;
        e.preventDefault();

        this.setState(prevState => ({
            xClick: x + this.state.xOff,
            clicked: true
        }));
    }

    onMouseUp(e) {
        this.setState(prevState => ({
            clicked: false
        }));
    }

    onMouseMove(e) {
        if (this.state.clicked) {
            let maxX = COL_WIDTH*dataTeams.length - 1920 + dataTeams.length*XPADDING;
            let xOff = Math.min(maxX, Math.max(0, this.state.xClick - e.clientX));
            this.setState({ mX: e.clientX, mY: e.clientY, xOff:xOff });
        }
    }

    onMouseScroll(e) {
        let maxX = COL_WIDTH*dataTeams.length - 1920 + dataTeams.length*XPADDING;
        let xOff = Math.min(maxX, Math.max(0, this.state.xOff + (20*e.deltaY)));
        this.setState({xOff:xOff});
        e.preventDefault();
    }

    render() {
        let xOff = this.state.xOff;
        let height = 200;
        let maxHeight = Math.max.apply(Math, dataTeams.map(function(obj){return obj.y;}));
        let maxBarHeight = height - COL_WIDTH - 30;

        dataTeams.sort(function(a, b) {
            return b.y - a.y;
        });

        let chart = dataTeams.map(function(value, i) {
            let h = value["y"]/maxHeight * maxBarHeight;
            let padding = i*XPADDING;
            let x = i*COL_WIDTH-xOff + padding;
            let chars = value["x"].split(',');
            
            let result = [];
            result.push(<rect width={COL_WIDTH} height={Math.max(1, h)} x={x} y={Math.max(height - h - COL_WIDTH, 1)} />);
            result.push(<image href={getCharFilename(chars[0], 0, "gray")} width={COL_WIDTH / 2} height={COL_WIDTH} x={x} y={height-COL_WIDTH*5/4} />);
            result.push(<image href={getCharFilename(chars[1], 0, "gray")} width={COL_WIDTH / 2} height={COL_WIDTH} x={x + COL_WIDTH / 2} y={height-COL_WIDTH*5/4} />);
            result.push(<text x={x + COL_WIDTH/2} y={height - h - COL_WIDTH - 10} textAnchor={"middle"}>{value["y"]}</text>);
            return result;
        });

        return (
            <svg className="TeamChart" width={1920} height={height} onMouseDown={this.onMouseDown.bind(this)} onMouseMove={this.onMouseMove.bind(this)} onMouseUp={this.onMouseUp.bind(this)} onWheel={(e) => this.onMouseScroll(e)} >
              { chart }
            </svg>
        );
    }
}

export default TeamChart;
